<template>
  <v-navigation-drawer
    persistent
    v-model="isOpened"
    enable-resize-watcher
    fixed
    app
    class="drawer"
  >
    <v-btn fab icon class="drawer__close" @click="$emit('close')">
      <i class="bexsicon-close" />
    </v-btn>
    <v-expansion-panel class="drawer__list">
      <v-expansion-panel-content
        expand-icon="bexsicon-down"
        v-for="(item, i) in allowedRoutes"
        :style="{
          display:
            !hasConditions(item)
              ? 'none'
              : 'initial',
        }"
        :key="i"
        :hide-actions="!shouldDropdown(item)"
        :readonly="!shouldDropdown(item)"
        class="drawer__list__item"
      >
        <div slot="header" @click="dropdownClicked(item)">
          <div class="drawer__list__item__header">
            <div
              :style="{ color: item.color }"
              class="drawer__list__item__header__icon"
            >
              <i :class="`bexsicon-${item.icon}`" />
            </div>
            <div class="drawer__list__item__header__title">
              {{ item.title }}
            </div>
          </div>
        </div>
        <v-list v-if="shouldDropdown(item)">
          <menu-units-select
            v-if="item.meta.unitsSelect && units.length > 1"
          ></menu-units-select>
          <span
            v-for="(subItem, i) in filterByPermission(item.dropdown)"
            :style="{
              display: !hasPermissionToView(subItem) ? 'none' : 'initial',
            }"
            :key="i"
          >
            <template v-if="subItem.subdivision">
              <v-list-tile
                v-for="(innerItem, i) in filterByConditions(
                  subItem.subdivision
                )"
                :key="i"
                @click="dropdownClicked(innerItem)"
              >
                <v-list-tile-title class="drawer__list__sub-item">{{
                  innerItem.title
                }}</v-list-tile-title>
              </v-list-tile>
            </template>
            <v-list-tile
              v-else-if="hasConditions(subItem)"
              @click="dropdownClicked(subItem)"
            >
              <v-list-tile-title class="drawer__list__sub-item">{{
                subItem.title
              }}</v-list-tile-title>
            </v-list-tile>
          </span>
        </v-list>
      </v-expansion-panel-content>
      <v-expansion-panel-content
        hide-actions
        readonly
        class="drawer__list__item"
      >
        <div slot="header" @click="$emit('logout')">
          <div class="drawer__list__item__header">
            <div class="drawer__list__item__header__icon">
              <i :class="`bexsicon-exit`" />
            </div>
            <div class="drawer__list__item__header__title">{{ $t('labels.logout') }}</div>
          </div>
        </div>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-navigation-drawer>
</template>

<script>
import bus from '@/utils/bus';
import { DOCS, NEWS_VIDEOS, UNIT, EVENTS, CONFIG } from '@/utils/constants';
import MenuUnitsSelect from '@/components/unitsSelect/MenuUnitsSelect';

export default {
  name: 'drawer-menu',
  components: {
    MenuUnitsSelect
  },
  computed: {
    conditions() {
      return {
        hasGeneralDocs: this.$store.getters[DOCS.HAS_GENERAL_DOCS],
        hasLegalDocs: this.$store.getters[DOCS.HAS_LEGAL_DOCS],
        hasDocs:
          this.$store.getters[DOCS.HAS_GENERAL_DOCS] ||
          this.$store.getters[DOCS.HAS_LEGAL_DOCS] ||
          this.$store.getters[DOCS.HAS_OWNER_DOCS],
        hasOwnerDocs: this.$store.getters[DOCS.HAS_OWNER_DOCS],
        hasNewsVideos: this.$store.getters[NEWS_VIDEOS.HAS_VIDEOS],
        showInConstruction: this.$store.getters[UNIT.GET_SHOW_IN_CONSTRUCTION],
        showDecorated: this.$store.getters[UNIT.GET_SHOW_DECORATED],
        notIndirectContract: !this.$store.getters[UNIT.GET_IS_INDIRECT],
        showDiscounts: this.$store.getters[UNIT.GET_DISCOUNT_LIST].length > 0,
        showBankFinancing:
          this.$store.getters[CONFIG.GET_JUNIX_BANK_FINANCING_BASE_URL].length >
            0 && this.$store.getters[UNIT.GET_IS_SETTLED] != true,
        showKeyDeliveryOption:
          !this.$store.getters[UNIT.GET_SELECTED].keyDeliveryDate && // ? does not have Keys delivered
          !!(this.$store.getters[EVENTS.GET_AGI] || {})._id && // ? has AGI Event
          !!(this.$store.getters[EVENTS.GET_KEYDELIVERY] || {})._id, // ? has Key delivery event
        hasInspection: this.checkInspection,
        hasSyndicDocs: this.$store.getters[DOCS.HAS_SYNDIC_DOCS]
      };
    },
    checkInspection() {
      return !!this.$store.getters[EVENTS.GET_INSPECTION];
    },
    allowedRoutes() {
      return this.routes.filter(item => {
        return (
          this.hasPermissionToView(item) &&
          (item.meta.module !== 'enterprise' || !this.isExceptionProduct)
        );
      });
    }
  },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    routes: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      isOpened: false
    };
  },
  created() {
    bus.$on('unit:change', this.close);
  },
  beforeDestroy() {
    bus.$on('unit:change', this.close);
  },
  methods: {
    close() {
      if (this.isOpened) {
        this.isOpened = false;
      }
    },

    shouldDropdown(item) {
      return (
        item.dropdown &&
        ((item.meta.dropDownConditions &&
          !item.meta.dropDownConditions.find(
            o => this.conditions[o] === false
          )) ||
          !item.meta.dropDownConditions)
      );
    },
    hasConditions(item) {
      return (
        (item.meta.conditions &&
          !item.meta.conditions.find(
            condition => this.conditions[condition] === false
          )) ||
        !item.meta.conditions
      );
    },
    dropdownClicked(item) {
      if (!this.shouldDropdown(item)) {
        this.close();
        if (item.path) this.$router.push(item.path);
        else if (item.vuexLink) {
          if (item.openForm) {
            this.$store.commit(item.vuexLink);
          } else {
            const link = this.$store.getters[item.vuexLink];
            window.open(link, '_blank');
          }
        }
      }
    },
    filterByConditions(array) {
      return array
        ? array.filter(item => {
            return (
              (item.meta.conditions &&
                !item.meta.conditions.find(
                  condition => this.conditions[condition] === false
                )) ||
              !item.meta.conditions
            );
          })
        : [];
    },
    filterByPermission(array) {
      return array.filter(item => this.hasPermissionToView(item));
    }
  },
  watch: {
    isOpened: function(newValue, oldValue) {
      if (!newValue) {
        this.$emit('close', newValue);
      }
    },
    value: function(newValue) {
      this.isOpened = newValue;
    }
  }
};
</script>

<style lang="scss" scoped>
.drawer {
  &__close {
    margin: 0;
    color: var(--brand-color);
  }

  &__list {
    box-shadow: none;

    &__item {
      &__header {
        display: flex;
        position: absolute;
        width: 80%;
        top: 25%;

        &__icon {
          font-size: 1.5em;
          flex: 0.2;
          margin-bottom: 1em;
        }

        &__title {
          flex: 0.7;
          font-size: 1em;
          color: var(--light-dark-color);
        }
      }
    }

    &__sub-item {
      color: var(--light-dark-color);
      font-size: 0.9em;
      left: 15%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/DrawerMenu.vue